<template>
    <div class="lg:grid lg:grid-cols-2 lg:gap-8">
        <div
            v-for="product in productCategory.products"
            :key="product.id"
            class="pb-8 lg:pb-0"
        >
            <div
                class="bg-white rounded-lg shadow-lg overflow-hidden border border-gray-200"
            >
                <div
                    class="mx-auto max-w-xs sm:max-w-md pt-6 pb-4 px-6 sm:px-8 xl:px-10"
                >
                    <a :href="productPageHref(product)">
                        <img
                            class="mx-auto"
                            :src="imgSrc(product, '1x')"
                            :srcset="imgSrcset(product)"
                            :alt="imgAlt(product)"
                        />
                    </a>
                </div>

                <div
                    class="flex flex-col justify-center pt-2 pb-6 px-6 sm:px-8 xl:px-10"
                >
                    <a
                        class="text-2xl lg:text-3xl text-center font-bold text-nutreance-green hover:text-nutreance-green-lighter"
                        :href="productPageHref(product)"
                    >
                        <h3 v-html="productTitle(product)" />
                    </a>

                    <p
                        v-html="productDescription(product)"
                        class="text-center text-lg text-gray-800 py-6 sm:px-6"
                    />

                    <div class="sm:flex sm:justify-center sm:items-center">
                        <a
                            role="button"
                            :href="productPageHref(product)"
                            class="sm:mr-2 w-full inline-flex justify-center px-6 py-3 my-2 border border-gray-300 shadow-sm text-base font-medium rounded-md text-gray-700 bg-white hover:bg-gray-50 focus:outline-none"
                        >
                            <ViewListIcon
                                class="shrink-0 h-5 w-5 mr-2"
                                aria-hidden="true"
                            />
                            Learn More
                        </a>

                        <a
                            role="button"
                            :href="`${productPageHref(product)}/add`"
                            class="sm:ml-2 w-full inline-flex justify-center items-center px-6 py-3 border border-transparent rounded-md shadow-sm font-sans text-white bg-nutreance-green hover:bg-nutreance-green-darker focus:outline-none"
                        >
                            <ShoppingCartIcon
                                class="shrink-0 h-5 w-5 mr-2"
                                aria-hidden="true"
                            />
                            Order Now
                        </a>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script setup lang="ts">
import { inject, onMounted, ref } from "vue";
import { ShoppingCartIcon, ViewListIcon } from "@heroicons/vue/solid";
import { useStaticAsset } from "../../functions/useStaticAsset";
import type { AppEmitter } from "../../emitter";

const props = defineProps<{
    initialProductCategory?: any;
}>();

const emitter = inject<AppEmitter>("mitt")!;
const { asset } = useStaticAsset();
const productCategory = ref(props.initialProductCategory);

function imgSrc(product: any, size: string) {
    const slug = product.slug;
    const upc = product.default_product_option.upc;
    const image = "bottle-3sides@1x.jpg".replace("@1x", `@${size}`);

    return asset(`/images/products/${slug}/${upc}/${image}`);
}

function imgAlt(product: any) {
    return `${product.name} (${product.description})`;
}

function imgSrcset(product: any) {
    return `${imgSrc(product, "1x")} 1x, ${imgSrc(product, "2x")} 2x, ${imgSrc(product, "3x")} 3x`;
}

function productPageHref(product: any) {
    return `/products/${product.slug}`;
}

function productTitle(product: any) {
    return product.card_title ?? product.name;
}

function productDescription(product: any) {
    return product.card_description;
}

onMounted(() => {
    emitter.on("productCategoryUpdated", (newProductCategory: any) => {
        productCategory.value = newProductCategory;
    });
});
</script>
